import { useState, useEffect, useRef } from 'react';
import './RulePage.css';
import CloseButton from '@/shared/components/CloseButton';

const ruleGetPoints = {
  title: "如何獲取積分？",
  items: [{
    subTitle: "《 參加網站互動活動 》",
    header: ["項目", "參與方式", "獲取積分"],
    body: [
      {
        task: "寄送明信片",
        description: "於首頁寄送明信片，親友點擊連結至網站觀看明信片。",
        points: "每次 20 分，上限100人。"
      },
      // {
      //   task: "願心樹",
      //   description: "於展區願心樹頁面發願。",
      //   points: "每次 20 分，上限100次。"
      // },
      {
        task: "點燈祈福",
        description: "完成點燈，獲得開山祖師法語。",
        points: "每獲得一則開山祖師法語 50 分，已獲得之法語不重複給分。<br />集滿一類別之全部法語，另獲得額外獎勵 100 分，故若集滿六類別之全部法語，可獲得 100×6 分。"
      },
      {
        task: "中台知多少",
        description: "完成作答。<br />每週更新題目。",
        points: "答對每題 10 分，全對額外獎勵 50 分。<br />每週首次作答計分，重複作答不計分。"
      },
      {
        task: "護法DNA",
        description: "完成測驗",
        points: "50 分，重複測驗不計分。"
      },
      {
        task: "禪心連線即時同步",
        description: "每月限時主題留言活動，在活動時間內留言或隨喜讚歎。",
        points: "留言成功獲 100 分。<br />隨喜加分：於活動時間內，隨喜按讚他人留言，當活動結束時，如有對「獲按讚前三名」按讚，可另外得 10 分。"
      },
      {
        task: "精舍傳燈應援",
        description: "至各精舍傳燈花絮頁面按讚。",
        points: "每日上限 5 次<br />為各精舍應援按讚<br />第1位得 100 分<br />第2-10位得 70 分<br />第11-100位得 50 分<br />第101-200位得 40 分<br />第201-400位得 30 分<br />第401-700位得 20 分<br />第701之後得 10 分"
      },
      {
        task: "線上精舍聯展應援",
        description: "至各精舍線上聯展頁面按讚。",
        points: "每日上限 5 次<br />為各精舍應援按讚<br />第1位得 100 分<br />第2-10位得 70 分<br />第11-100位得 50 分<br />第101-200位得 40 分<br />第201-400位得 30 分<br />第401-700位得 20 分<br />第701之後得 10 分"
      }]
  },
  {
    subTitle: "《 參與指定實體活動／掃描QR Code 》",
    header: ["項目", "參與方式", "獲取積分"],
    body: [
      {
        task: "開山祖師圓寂十週年紀念法會",
        description: "出席參加，並於活動現場掃描QR Code",
        points: "600 分（限 1 次）"
      },
      {
        task: "浴佛法會",
        description: "出席參加，並於活動現場掃描QR Code",
        points: "600 分（限 1 次）"
      },
      {
        task: "供佛齋僧法會",
        description: "出席參加，並於活動現場掃描QR Code",
        points: "600 分（限 1 次）"
      },
      {
        task: "中台三合一法會",
        description: "出席參加，並於活動現場掃描QR Code",
        points: "600 分（限 1 次）"
      },
      {
        task: "護法薪傳 精進報恩——護法會博覽會",
        description: "出席參加，並於活動現場掃描QR Code",
        points: "500 分（限 1 次）"
      },
      {
        task: "中台心傳 法水長流——海內外精舍聯展",
        description: "出席參加，並於活動現場掃描QR Code",
        points: "500 分（上限 3 次）"
      },
      {
        task: "精舍傳燈或供燈法會",
        description: "出席參加，並於活動現場掃描QR Code",
        points: "300 分（上限 3 次）"
      }
    ]
  }
  ]
}
const ruleGetMascot = {
  title: "積分兌換",
  items: [{
    subTitle: "《 註冊後第一隻吉祥物 》",
    header: ["兌換項目", "所需點數", "活動連動解鎖（加速機制）"],
    body: [
      {
        task: "住 (Stand)",
        description: "0 分",
        points: "註冊即解鎖"
      },
      {
        task: "行 (Walk)",
        description: "1,200 分",
        points: "參加「精舍傳燈或供燈法會」，現場掃碼。"
      },
      {
        task: "坐 (Sit)",
        description: "1,200 分",
        points: "參加「護法會頒證大典」或「三合一法會」，現場掃碼。"
      },
      {
        task: "臥 (Lie)",
        description: "1,200 分",
        points: "完成「精舍聯展」巡禮"
      },
    ]
  },
  {
    subTitle: "《 註冊後第二隻吉祥物 》",
    header: ["兌換項目", "所需點數"],
    body: [
      {
        task: "吉祥物（住）第2隻起",
        points: "2,000 分"
      },
      {
        task: "行、坐、臥",
        points: "各 1,200 分"
      },
      {
        task: "配件、背景",
        points: "各 500 分"
      },
    ]
  }]

}
const ruleGetGift = {
  title: "積分達標特別獎勵",
  items: [{
    subTitle: "35週年功德圓滿【神秘禮物】",
    header: ["階段", "兌換門檻"],
    body: [
      {
        task: "第一階段",
        description: "累積達 5,000 分，且參加【精舍傳燈或供燈】法會，於現場完成掃描 QR Code 至少一次。",
      },
      {
        task: "第二階段",
        description: "累積達 10,000 分，且參觀【中台心傳 法水長流——海內外精舍聯展】，於現場掃描 QR Code",
      },
      {
        task: "第三階段",
        description: "累積達 15,000 分，且參加過精舍聯展至少一次，可兌換金頂童子鑰匙圈 1 個。",
      },
      {
        task: "第四階段",
        description: "累積達 20,000 分，且參加過精舍聯展至少一次，可兌換金頂童子絨毛娃娃 1 個或金頂童子鑰匙圈 2 個。",
      },
    ]
  }]
}


export default function RulePages({ isOpen, onClose, target }) {
  const [internalIsOpen, setInternalIsOpen] = useState(true);
  const scrollContainerRef = useRef(null);

  const displayOpen = isOpen !== undefined ? isOpen : internalIsOpen;

  const handleClose = () => {
    if (onClose) onClose();
    setInternalIsOpen(false);
  };

  useEffect(() => {
    if (displayOpen && target) {
      setTimeout(() => {
        const el = document.getElementById(`section-${target}`);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, [displayOpen, target]);

  if (!displayOpen) return null;

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center p-4 bg-black/50">
      <div className="relative bg-[#f0f4fa] rounded-2xl w-[95vw] sm:max-w-[430px] md:max-w-[600px] lg:max-w-[800px] max-h-[90vh] overflow-hidden flex flex-col shadow-2xl rule-page-container">
        {/* Close Button */}
        <CloseButton onClick={handleClose} />
        {/* Scrollable Content */}
        <div ref={scrollContainerRef} className="overflow-y-auto overflow-x-hidden w-full h-full py-8 page">

          {/* Reasons Area */}
          <div className="reasons-area">
            <div className="reasons-card">
              <div className="title">參與積分計畫的三個理由？</div>
              <div className="item">• 同慶中台開山三十五週年</div>
              <div className="item">• 廣結善緣，廣增福慧</div>
              <div className="item">• 積分達標，除兌換線上獎勵外，另可兌換實體神秘小禮物哦！</div>
            </div>
            <img src="image/mascot/gb_walk.png"
              style={{ height: 'auto', maxWidth: '85px' }} />
          </div>

          {/* 如何獲取積分？ Banner */}
          <div id="section-points" className="section-banner">
            <h2>{ruleGetPoints.title}</h2>
          </div>

          {ruleGetPoints.items.map((item, index) => (
            <div key={index}>
              <div className="sub-title">{item.subTitle}</div>
              {index === 1 ? (
                <>
                  {/* Mobile: show image */}
                  {/* <div className="sm:hidden w-full">
                    <img src="image/else/rule_active_sm.jpg" alt="參與指定實體活動" className="w-full h-auto" />
                  </div> */}
                  {/* Desktop: show full content */}
                  <div className={`data-table t${index + 1}`} style={{ marginTop: '4px' }}>
                    <div className="thead">
                      {item.header.map((col, hIdx) => (
                        <div key={hIdx} className={`th c${hIdx + 1}`}>{col}</div>
                      ))}
                    </div>
                    {item.body.map((row, rIdx) => (
                      <div key={rIdx} className={`row ${rIdx % 2 !== 0 ? 'alt' : ''}`}>
                        <div className="cell label c1 flex flex-col justify-center text-center" dangerouslySetInnerHTML={{ __html: row.task }} />
                        <div className="cell desc c2 flex flex-col justify-center" dangerouslySetInnerHTML={{ __html: row.description }} />
                        <div
                          className="cell points c3 flex flex-col justify-center"
                          style={{ color: '#1a3a6e', fontWeight: 600, fontSize: '12.5px' }}
                          dangerouslySetInnerHTML={{ __html: row.points }}
                        />
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <>
                  <div className={`data-table t${index + 1}`} style={{ marginTop: '4px' }}>
                    <div className="thead">
                      {item.header.map((col, hIdx) => (
                        <div key={hIdx} className={`th c${hIdx + 1}`}>{col}</div>
                      ))}
                    </div>
                    {item.body.map((row, rIdx) => (
                      <div key={rIdx} className={`row ${rIdx % 2 !== 0 ? 'alt' : ''}`}>
                        <div className="cell label c1 flex flex-col justify-center text-center" dangerouslySetInnerHTML={{ __html: row.task }} />
                        <div className="cell desc c2 flex flex-col justify-center" dangerouslySetInnerHTML={{ __html: row.description }} />
                        <div
                          className="cell points c3 flex flex-col justify-center"
                          dangerouslySetInnerHTML={{ __html: row.points }}
                        />
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          ))}

          {/* 積分兌換 Section */}
          <div id="section-mascot" className="exchange-section">
            <div className="section-banner" style={{ position: 'absolute', top: '70px' }}>
              <h2>{ruleGetMascot.title}</h2>
            </div>
            <div className="mascot-overlay exchange">
              <img src="image/mascot/gb_sit.png"
                style={{ height: 'auto', maxWidth: '70px' }} />
            </div>

            {ruleGetMascot.items.map((item, index) => (
              <div key={index}>
                <div className="sub-title">{item.subTitle}</div>
                <div className={`data-table gold gold-border ex${index + 1}`} style={{ marginTop: '4px' }}>
                  <div className="thead">
                    {item.header.map((col, hIdx) => (
                      <div key={hIdx} className={`th c${hIdx + 1}`}>{col}</div>
                    ))}
                  </div>
                  {item.body.map((row, rIdx) => (
                    <div key={rIdx} className={`row ${rIdx % 2 !== 0 ? 'alt' : ''}`}>
                      <div className="cell label c1" dangerouslySetInnerHTML={{ __html: row.task }} />
                      {row.description ? (
                        <>
                          <div className="cell points-gold c2" dangerouslySetInnerHTML={{ __html: row.description }} />
                          <div className="cell c3" dangerouslySetInnerHTML={{ __html: row.points }} />
                        </>
                      ) : (
                        <div className="cell points-gold c2" dangerouslySetInnerHTML={{ __html: row.points }} />
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* 積分達標特別獎勵 Section */}
          <div id="section-gift">
            <div className="rewards-section" style={{ position: 'relative' }}>
              <div className="section-banner section-banner-sm" style={{ position: 'absolute', top: '70px', zIndex: 1 }}>
                <h2 className="relative z-10 px-4">{ruleGetGift.title}</h2>
              </div>
              <div className="absolute z-[5] top-10 right-2 sm:right-8 md:right-20 lg:right-28 ">
                <img src="image/mascot/gb_stand.png"
                  className="h-auto w-[60px]" />
              </div>

              <div className="rewards-box">
                {ruleGetGift.items.map((item, index) => (
                  <div key={index}>
                    <div className="badge-wrap">
                      <div className="badge-pill"><span>{item.subTitle}</span></div>
                      <div className="badge-sub">積分達標，除兌換線上獎勵外，另可兌換實體神秘小禮物哦！</div>
                    </div>

                    <div className="data-table rw" style={{ marginTop: '0' }}>
                      <div className="thead">
                        {item.header.map((col, hIdx) => (
                          <div key={hIdx} className={`th c${hIdx + 1}`}>{col}</div>
                        ))}
                      </div>
                      {item.body.map((row, rIdx) => (
                        <div key={rIdx} className="row">
                          <div className="cell label c1" dangerouslySetInnerHTML={{ __html: row.task }} />
                          <div className="cell c2" style={{ lineHeight: 1.7 }} dangerouslySetInnerHTML={{ __html: row.description }} />
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="footer">
            <div className="footer-mascot">
              <img src="image/mascot/gb_lie.png"
                style={{ height: 'auto', maxWidth: '100px' }} />
            </div>
            <div className="sm:hidden w-full">
              <img src="image/else/rule_footer_sm.jpg" alt="footer" className="w-full h-auto mr-4" />
            </div>
            <div className="footer-verse hidden sm:block">修習空花萬行，宴坐水月道場，<br />降伏鏡裏魔軍，大作夢中佛事。</div>
          </div>

        </div>
      </div>
    </div>
  );
}
